import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Tooltip } from '../../../../common/tooltip'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../../utils/authorization'
import { mapTransactionStatus } from '../constants'

const WIDTH_PAYMENT_STATUS = 90

export const PaymentStatusCell = ({ val, orderStatus, handlePayNow }) => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const isDisableCheckout =
    AUTHORIZATION_API.allowCheckout[userType.userTypeId] ===
    AUTHORIZATION_TYPE.DISABLE

  return (
    <div className="dFlex gap2">
      <Element
        elementName="span"
        style={{
          color: mapTransactionStatus[val]?.color,
          width: WIDTH_PAYMENT_STATUS,
        }}
      >
        <Translate
          value={
            'userManagement.orderManagement.' + mapTransactionStatus[val]?.title
          }
        />
      </Element>
      {val !== mapTransactionStatus.Success.key &&
        val !== mapTransactionStatus.Cancelled.key &&
        val !== mapTransactionStatus.Checking.key &&
        orderStatus !== mapTransactionStatus.Cancelled.key &&
        (isDisableCheckout ? (
          <Tooltip
            zIndex={13}
            contentClass="dFlex"
            tooltipContent={<Translate value="cartAndOrders.message.m20" />}
          >
            <Element
              elementName="span"
              className="cursorPointer"
              style={{ color: '#9C9C9C' }}
            >
              <Translate value="userManagement.orderManagement.PAY_NOW" />
            </Element>
          </Tooltip>
        ) : (
          <Element
            elementName="span"
            className="cursorPointer"
            style={{ color: '#2C73E8' }}
            onClick={handlePayNow}
          >
            <Translate value="userManagement.orderManagement.PAY_NOW" />
          </Element>
        ))}
    </div>
  )
}
